module.exports = __webpack_public_path__ + "img/android9.9ab4c5f3.jpg";